import React from 'react';
import { ShoppingCart, Briefcase, Users, FileText, Calendar, Mail, MessageSquare, Image } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const QuickPrompts = ({ onSelectPrompt }) => {
  const prompts = [
    {
      icon: ShoppingCart,
      category: 'E-commerce',
      title: 'Online Store',
      description: 'Create an e-commerce platform with product listings, cart, and checkout',
      prompt: 'Build an e-commerce store with product catalog, shopping cart, user authentication, and Stripe payment integration',
    },
    {
      icon: Briefcase,
      category: 'Business',
      title: 'Portfolio Website',
      description: 'Professional portfolio to showcase your work and skills',
      prompt: 'Create a professional portfolio website with project showcase, about section, skills display, and contact form',
    },
    {
      icon: FileText,
      category: 'Content',
      title: 'Blog Platform',
      description: 'Blogging platform with posts, categories, and comments',
      prompt: 'Build a blog platform with article management, categories, tags, markdown support, and comment system',
    },
    {
      icon: Users,
      category: 'Social',
      title: 'Social Network',
      description: 'Social platform with profiles, posts, and connections',
      prompt: 'Create a social networking app with user profiles, post feed, likes, comments, and follow system',
    },
    {
      icon: Calendar,
      category: 'Productivity',
      title: 'Task Manager',
      description: 'Todo app with projects, tasks, and team collaboration',
      prompt: 'Build a task management app with projects, todos, priority levels, due dates, and team collaboration',
    },
    {
      icon: Mail,
      category: 'Communication',
      title: 'Email Client',
      description: 'Email management interface with inbox and compose',
      prompt: 'Create an email client interface with inbox, compose, folders, search, and email threading',
    },
    {
      icon: MessageSquare,
      category: 'Communication',
      title: 'Chat Application',
      description: 'Real-time messaging with channels and direct messages',
      prompt: 'Build a real-time chat application with channels, direct messages, file sharing, and online status',
    },
    {
      icon: Image,
      category: 'Media',
      title: 'Photo Gallery',
      description: 'Image gallery with albums, tags, and sharing',
      prompt: 'Create a photo gallery app with albums, image upload, tagging, search, and social sharing',
    },
  ];

  return (
    <div className="px-6 py-8 bg-gradient-to-br from-purple-50 to-blue-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            What would you like to build?
          </h2>
          <p className="text-gray-600">
            Choose a template below or describe your own idea
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {prompts?.map((prompt, index) => {
            const Icon = prompt?.icon;
            return (
              <button
                key={index}
                onClick={() => onSelectPrompt(prompt?.prompt)}
                className="bg-white rounded-lg p-4 hover:shadow-lg hover:scale-105 transition-all duration-200 text-left border-2 border-transparent hover:border-purple-200 group"
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center group-hover:bg-purple-200 transition-colors">
                    <Icon className="w-5 h-5 text-purple-600" />
                  </div>
                  <div className="flex-1">
                    <span className="text-xs font-medium text-purple-600 uppercase tracking-wide">
                      {prompt?.category}
                    </span>
                    <h3 className="font-semibold text-gray-900 mt-1">
                      {prompt?.title}
                    </h3>
                  </div>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {prompt?.description}
                </p>
              </button>
            );
          })}
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            💡 Tip: Be specific about features, design style, and functionality for best results
          </p>
        </div>
      </div>
    </div>
  );
};

export default QuickPrompts;